import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgSearch;
